import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import { copyableModel } from 'frontend-utils/utils/ember-data';

@copyableModel
export default class RevenueInsightSegmentationData extends Model {
  [Type] = 'revenue-insight/segmentation-data' as const;

  @attr('number') declare adr?: number | null;
  @attr('number') declare adrContractedCrew?: number | null;
  @attr('number') declare adrGroup?: number | null;
  @attr('number') declare adrOther?: number | null;
  @attr('number') declare adrTotal?: number | null;
  @attr('number') declare adrTransient?: number | null;
  @attr('number') declare adrUnmapped?: number | null;
  @attr('number') declare capacity?: number | null;
  @attr() declare message?: unknown;
  @attr('number') declare nrOfRooms?: number | null;
  @attr('number') declare nrOfRoomsContractedCrew?: number | null;
  @attr('number') declare nrOfRoomsGroup?: number | null;
  @attr('number') declare nrOfRoomsOther?: number | null;
  @attr('number') declare nrOfRoomsOutOfOrder?: number | null;
  @attr('number') declare nrOfRoomsTotal?: number | null;
  @attr('number') declare nrOfRoomsTransient?: number | null;
  @attr('number') declare nrOfRoomsUnmapped?: number | null;
  @attr('number') declare revenue?: number | null;
  @attr('number') declare revenueContractedCrew?: number | null;
  @attr('number') declare revenueGroup?: number | null;
  @attr('number') declare revenueOther?: number | null;
  @attr('number') declare revenueTotal?: number | null;
  @attr('number') declare revenueTransient?: number | null;
  @attr('number') declare revenueUnmapped?: number | null;
}

export function isSegmentationDataKey(
  potentialKey: string,
  // @ts-expect-error: A type predicate's type must be assignable to its parameter's type.
): potentialKey is keyof RevenueInsightSegmentationData {
  return potentialKey in RevenueInsightSegmentationData.prototype;
}

export type RevenueInsightSegmentationDataLike = Partial<
  Omit<RevenueInsightSegmentationData, keyof Model>
>;
